import React from 'react';
import { AppTemplateProvidersProps } from './types/app-template-providers-props';
import { CoreProviders } from './app-template-providers';
import { DesktopOidcProvider } from '@revenuewell/logic-desktop-oidc';
import { useConfig } from '@revenuewell/logic-config';
import { AdminInterceptProvider, OidcProvider } from '@revenuewell/logic-oidc';
import { ProductProvider } from '@revenuewell/logic-product';
import { FeatureFlagsProvider } from '@revenuewell/logic-feature-flags';
import { VirtualVisitProvider } from '@revenuewell/logic-virtual-visit';
import { SmsProvider } from '@revenuewell/logic-sms';
import AnalyticsProvider from '../../hooks/analytics/analytics';
import { ContactProvider } from '@revenuewell/logic-contact';
import { PermissionProvider } from '@revenuewell/logic-permission';

export function PrivateAppTemplateProviders(
  props: React.PropsWithChildren<AppTemplateProvidersProps>
) {
  return (
    <CoreProviders {...props}>
      <ConfigDependantProviders {...props}>
        {props.children}
      </ConfigDependantProviders>
    </CoreProviders>
  );
}

function ConfigDependantProviders(
  props: React.PropsWithChildren<AppTemplateProvidersProps>
) {
  const { config } = useConfig();

  return (
    // todo: review why we started to use reference tokens for the desktop app
    // sign out issue for the desktop for the jwt token
    <OidcProvider oidcConfig={config.oidc} checkSessionOnStart={true}>
      <AdminInterceptProvider>
        <DesktopOidcProvider>
          <PermissionProvider>
            <ProductProvider preloadOnStart={props.preload?.products}>
              <FeatureFlagsProvider>
                <ContactProvider>
                  <VirtualVisitProvider>
                    <SmsProvider>
                      <AnalyticsProvider>{props.children}</AnalyticsProvider>
                    </SmsProvider>
                  </VirtualVisitProvider>
                </ContactProvider>
              </FeatureFlagsProvider>
            </ProductProvider>
          </PermissionProvider>
        </DesktopOidcProvider>
      </AdminInterceptProvider>
    </OidcProvider >
  )
}
